import request from "../utils/request"
export function reboot(data) {
    return request({
        url: '/phone/reboot',
        method: 'post',
        data
    })
}

export function setgps(data) {
    return request({
        url: '/phone/set_gps',
        method: 'post',
        data
    })
}

export function resetphone(data) {
    return request({
        url: '/phone/reset',
        method: 'post',
        data
    })
}

export function renewphone(data) {
    return request({
        url: '/phone/renew',
        method: 'post',
        data
    })
}

export function setroot(data) {
    return request({
        url: '/phone/set_root',
        method: 'post',
        data
    })
}

export function importfile(data) {
    return request({
        url: '/phone/import_file',
        method: "post",
        data
    })
}


